import { render, staticRenderFns } from "./reset-pwd.vue?vue&type=template&id=4e01dfd8&scoped=true&"
import script from "./reset-pwd.vue?vue&type=script&lang=js&"
export * from "./reset-pwd.vue?vue&type=script&lang=js&"
import style0 from "./reset-pwd.vue?vue&type=style&index=0&id=4e01dfd8&prod&lang=scss&"
import style1 from "./reset-pwd.vue?vue&type=style&index=1&id=4e01dfd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e01dfd8",
  null
  
)

export default component.exports